import { Injectable } from '@angular/core';
import { CepDataService } from './cep-data.service';
import {CepModel} from "./model/cep.model";

@Injectable({
  providedIn: 'root'
})
export class CepMockService implements CepDataService{

  readonly cepAll = [];

  constructor() {
    this.cepAll.push(this.getCepBoaVista());
    this.cepAll.push(this.getCepSantos());
    this.cepAll.push(this.getCepEmpty());
    this.cepAll.push(this.getCepNotFound());
    this.cepAll.push(this.getAPIError());
  }

  public getCep(cepId: string): Promise<CepModel> {
    const cepFound = this.cepAll.find(r => r.code === cepId || r.code === '');
    if (cepFound) {
      return Promise.resolve(cepFound.data);
    } else {
      return Promise.reject(new Error('CEP não encontrado'));
    }
  }

  protected getCepBoaVista() {
    return {
      code : '00000001',
      data: {
        postal_code: '00000001',
        street_type: 'R',
        street: 'Boa Vista',
        district: 'Centro',
        city: 'São Paulo',
        state: 'SP'
      }
    };
  }

  protected getCepSantos() {
    return {
      code : '00000005',
      data: {
        postal_code: '00000005',
        street_type: 'R',
        street: 'Ilha Branca',
        district: 'João Fernandes',
        city: 'Armação dos Búzios',
        state: 'RJ'
      }
    };
  }

  protected getCepEmpty() {
    return {
      code : '00000002',
      data: {
        postal_code: '00000002',
        street_type: '',
        street: '',
        district: '',
        city: 'Afega',
        state: 'AF'
      }
    };
  }

  protected getCepNotFound() {
    return {
      code : '00000003',
      data: {
        cepNotFound: true,
      }
    };
  }

  protected getAPIError() {
    return {
      code : '00000004',
      message: "Timeout",
      data: undefined
    };
  }
  
  
}
